import './App.css';
import About from './Components/About/About';
import Banner from './Components/Banner/Banner';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import Portfolio from './Components/Portfolio/Portfolio';
import Services from './Components/Services/Services';
import Skills from './Components/Skills/Skills';
import Testimonials from './Components/Testimonials/Testimonials';
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';
import Header from './Components/Header/Header';
import Preloader from './Components/Preloader';
import { useState } from 'react';

function App() {

  // const [loader, setLoader] = useState(true);

  useEffect(() => {
    // setLoader(false);
    Aos.init({ duration: 2000 });
  }, [])

  return (
    <>
      {/* {
        loader &&
        <Preloader />
      } */}
      <Header />
      <Banner />
      <About />
      <Services />
      <Portfolio />
      <Skills />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
